import { debounce } from 'lodash/function';

import { ACT_RECORD_FIELD_NAMES } from '../../constants/actRecord';
import { getActRecordVersionByDate } from '../../helpers/actRecord';
import { CHANGE_ACT_RECORD_DATA } from '../constants';
import { actRecordDataSelector } from '../actRecord/selectors';
import { mainDataValuesSelector } from '../mainData/selectors';
import validator from '../../helpers/validator';
import { findRegPlaceNames } from '../../resources';
import {
  getRegPlaceSuggestions,
  getRegPlaceSuggestionsError,
  getRegPlaceSuggestionsSuccess,
} from '../actRecord/actions';

const changeActRecordMiddleware =
  ({ getState, dispatch }) =>
  (next) =>
  (action) => {
    const { payload, type } = action;

    if (type !== CHANGE_ACT_RECORD_DATA) {
      return next(action);
    }

    const state = getState();
    const actRecordData = actRecordDataSelector(state);
    const mainData = mainDataValuesSelector(state);
    const actRecordDate = actRecordData[ACT_RECORD_FIELD_NAMES.date].value;
    const actRecordNumber = actRecordData[ACT_RECORD_FIELD_NAMES.number].value;
    const actRecordVersion = getActRecordVersionByDate(actRecordDate);

    const {
      target: { name, value },
    } = payload;
    const isRegPlaceField = name === ACT_RECORD_FIELD_NAMES.regPlace;
    const textValue = value?.hasOwnProperty('text') ? value.text : value;
    const normValue = textValue?.trim() || '';
    const newPayload = {
      [name]: {
        value,
        error: false,
      },
    };

    if (
      name === ACT_RECORD_FIELD_NAMES.number &&
      normValue &&
      actRecordNumber !== normValue
    ) {
      // Заменяем латинскую "B" на кириллическую "В"
      newPayload[name].value = normValue.replace(/B+/gi, 'В');
    }

    const isAllowedToSearch =
      isRegPlaceField && !value.skipSearch && normValue?.length > 2;

    const getRegPlaceNames = () => {
      findRegPlaceNames({ query: normValue })
        .then((response) => {
          if (response.data?.marriage_registries) {
            dispatch(
              getRegPlaceSuggestionsSuccess(response.data?.marriage_registries),
            );
          } else {
            dispatch(getRegPlaceSuggestionsError());
          }
        })
        .catch((error) => {
          dispatch(getRegPlaceSuggestionsError());
        });
    };

    if (isAllowedToSearch) {
      const getSuggestions = () => {
        dispatch(getRegPlaceSuggestions());

        getRegPlaceNames();
      };

      debounce(getSuggestions, 500)();
    }

    const validationObj = validator(
      {
        ...mainData,
        ...actRecordData,
        [name]: {
          ...actRecordData[name],
          value: isRegPlaceField ? value : normValue,
          skipSearch: value?.skipSearch,
        },
      },
      'act_record',
      actRecordVersion,
      true,
    );

    newPayload[name] = {
      value,
      error: validationObj.errors[name],
    };

    return next({
      ...action,
      payload: newPayload,
    });
  };

export default changeActRecordMiddleware;
